import React, { useState }from 'react';
import SftGlobalData from '../../library/SftGlobalData';
import { Switch } from '@mui/material';
import axios from 'axios';

const LicenceAdministrationCheckBox = (props) =>  { 
    const [checked, setChecked] = useState(props.checked);

    const changeListener = () => {
        updateModule({key: props.api, field: props.mod, user: props.username, sftUserId: props.userId});
        setChecked(!checked);
    }

    const updateModule = (postData) => {
        SftGlobalData.post('client&action=updateAdministration', postData).then(response => {
            if(response.status === 200){
                props.notify(response.data.message, 5000, "top-center", props.theme, 1); 
            }
        });
    }

    return (
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', justifyContent: 'center'}}>
            <Switch
                disabled={props.disabled}
                checked={ checked }
                onChange={() => {changeListener();}}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            {props.label}
        </div>
    );
}

export default LicenceAdministrationCheckBox;
